@import '~less/global-variables';

/**
 * Spinner loading animation
 * Adapted from http://codepen.io/mrrocks/pen/EiplA
 */

@spinner-offset: 94;
@spinner-duration: 1.4s;

.spinner {
  animation: rotator @spinner-duration linear infinite;
}

@keyframes rotator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
}

.spinner-path {
  stroke-dasharray: @spinner-offset;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation:
    spinnerDash @spinner-duration ease-in-out infinite,
    spinnerColors (@spinner-duration * 4) ease-in-out infinite;
}

@keyframes spinnerColors {
  0% {
    stroke: @color-reel-0;
  }
  25% {
    stroke: @color-reel-1;
  }
  50% {
    stroke: @color-reel-2;
  }
  75% {
    stroke: @color-reel-3;
  }
  100% {
    stroke: @color-reel-4;
  }
}

@keyframes spinnerDash {
  0% {
    stroke-dashoffset: @spinner-offset;
  }
  50% {
    stroke-dashoffset: @spinner-offset / 4;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: @spinner-offset;
    transform: rotate(450deg);
  }
}
